module.exports = __webpack_public_path__ + "static/img/witness-kids.7d83727b.png";